import { Auth } from 'aws-amplify';

// Username PW
export const signInWithUsername = (username, password) => {
  return new Promise((resolve, reject) => {
    Auth.signIn(username, password)
      .then(user => {
        console.log('USER login success: ', user);
        resolve(user)
      })
      .catch(err => {
        console.log('USER signIn error: ', err);
        reject(err)
      });
  });
};


// Change password at the first time login
export const completeNewPassword = (user, password) => {
  return new Promise((resolve, reject) => {
    Auth.completeNewPassword(user, password)
      .then(user => {
        console.log('USER login success: ', user);
        resolve(user)
      })
      .catch(err => {
        console.log('USER complete password error: ', err);
        reject(err)
      });
  });
};



export const logout = () => {
  return new Promise(async (resolve, reject) => {
    Auth.signOut()
      .then(() => {
        resolve('success');
      })
      .catch(err => {
        console.log(err);
        reject(err);
      });
  });
};

